import type React from 'react';
import { DashboardView } from './DashboardView';
import { useDashboard } from './useDashboard';

/**
 * Admin dashboard container. Where a branch admin lands after PIN — the
 * management overview, rendered inside the admin app shell (sidebar + navbar).
 * Thin composition point: logic in `useDashboard`, render in `DashboardView`.
 */
export const Dashboard: React.FC = () => {
    const logic = useDashboard();
    return <DashboardView {...logic} />;
};
